import templateUrl from 'emun.vendor/stripe/stripe-connected.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class StripeConnectedController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		    $ctrl.bus = new ServiceBus();
        $ctrl.bus
        .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
        .then(function(res) {
          if (res.data.results.length > 0) $ctrl.vendor = res.data.results[0];
        });
    }

}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: StripeConnectedController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};